//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  layout: 'blog',

  data() {
    return { activeId: null };
  },

  async asyncData({ $content, params, error }) {
    const post = await $content('blog', params.slug)
      .fetch()
      .catch(() => {
        error({ statusCode: 404, message: 'Post not found' });
      });

    const morePosts = await $content('blog')
      .where({ slug: { $ne: params.slug } })
      .only(['title', 'slug', 'excerpt', 'featuredImage', 'publishedOn'])
      .sortBy('publishedOn', 'desc')
      .limit(3)
      .fetch();

    return { post, morePosts };
  },

  mounted() {
    if (!this.post.toc || !this.post.toc.length) return;

    const headings = document.querySelectorAll(
      '.nuxt-content h2, .nuxt-content h3'
    );
    if (!headings.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.activeId = entry.target.id;
        });
      },
      { rootMargin: '-10% 0px -80% 0px' }
    );

    headings.forEach((h) => observer.observe(h));
    this.$once('hook:beforeDestroy', () => observer.disconnect());
  },

  head() {
    return {
      title: `${this.post.title} | BOMIST Blog`,
      meta: [
        { hid: 'description', name: 'description', content: this.post.excerpt },
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${this.post.title} | BOMIST Blog`
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.post.excerpt
        },
        ...(this.post.featuredImage
          ? [
              {
                hid: 'og:image',
                property: 'og:image',
                content: `https://bomist.com${this.post.featuredImage}`
              }
            ]
          : []),
        { hid: 'og:type', property: 'og:type', content: 'article' },
        {
          hid: 'twitter:card',
          name: 'twitter:card',
          content: 'summary_large_image'
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: `${this.post.title} | BOMIST Blog`
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: this.post.excerpt
        },
        ...(this.post.featuredImage
          ? [
              {
                hid: 'twitter:image',
                name: 'twitter:image',
                content: `https://bomist.com${this.post.featuredImage}`
              }
            ]
          : [])
      ],
      script: [
        {
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'BlogPosting',
            headline: this.post.title,
            description: this.post.excerpt,
            url: `https://bomist.com/blog/${this.post.slug}`,
            datePublished: this.post.publishedOn,
            ...(this.post.updatedOn && { dateModified: this.post.updatedOn }),
            ...(this.post.featuredImage && {
              image: `https://bomist.com${this.post.featuredImage}`
            }),
            author: {
              '@type': 'Organization',
              name: 'BOMIST',
              url: 'https://bomist.com'
            },
            publisher: {
              '@type': 'Organization',
              name: 'BOMIST',
              url: 'https://bomist.com',
              logo: {
                '@type': 'ImageObject',
                url: 'https://bomist.com/bomist_og_logo.png'
              }
            }
          }
        }
      ]
    };
  }
};
